export default __webpack_public_path__ + "static/media/raya-bg.79706aef.png";